import { KeyValueGambit } from 'flarum/common/query/IGambit';
import app from 'flarum/common/app';
export default class LikedByGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('flarum-likes.lib.gambits.posts.likedBy.key', {}, true);
  }
  canonicalKey() {
    return 'likedBy';
  }
  hint() {
    return app.translator.trans('flarum-likes.lib.gambits.posts.likedBy.hint', {}, true);
  }
  filterKey() {
    return 'likedBy';
  }
}
flarum.reg.add('flarum-likes', 'common/query/posts/LikedByGambit', LikedByGambit);